/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { JSONable } from '@irian-ro/abstract-resource';
import { AccountStatusDtoModel } from './sign-up/account-status-dto.model';
import { LegalEntityModel } from '@well/common-libs/legal-entity-management/domain-model';

export class CompanyDetailsDtoModel extends JSONable {
  legalEntityDTO: LegalEntityModel | undefined = undefined;
  createServiceProvider: boolean | undefined = undefined;
  invoiceSeriesPrefix?: string;
  accountStatus?: AccountStatusDtoModel;
  accountStatusDto: any | undefined = undefined;

  constructor(legalEntityDTO?: LegalEntityModel, createServiceProvider?: boolean, accountStatus?: AccountStatusDtoModel) {
    super();
    this.legalEntityDTO = legalEntityDTO ? legalEntityDTO : undefined;
    this.createServiceProvider = createServiceProvider ? createServiceProvider : undefined;
    this.accountStatus = accountStatus ? accountStatus : undefined;
  }
}
